import * as React from 'react';
import _ from 'lodash';
import { Grid, Head } from 'semantic-grab-ui/src';
import './WidgetComponent.scss';
import { Campaign } from 'types/ts/campaigns';

const ExperimentShow = ({
  model,
  currentNode,
}: {
  model: Campaign;
  currentNode: string;
}) => {
  const treatmentPercentages = _.get(model.nodes[currentNode], 'data.groupPercentage', []);
  const controlPercentage = 100 - _.sum(treatmentPercentages);
  return (
    <div>
      <div>
        <Grid>
          <Grid.Column width={12}>
            Groups percentage
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column width={8}>
            Control Group Percentage
          </Grid.Column>
          <Grid.Column width={4}>
            {controlPercentage}%
          </Grid.Column>
        </Grid>
        {treatmentPercentages.map((percentage, index) =>
          (<Grid key={`${percentage}-${index}`}>
            <Grid.Column width={8}>
              Treatment {index + 1} Group Percentage
            </Grid.Column>
            <Grid.Column width={4}>
              {percentage}%
            </Grid.Column>
          </Grid>)
        )}
      </div>
    </div>
  );
};

export default ExperimentShow;
